// extracted by mini-css-extract-plugin
export var inline = "_vl-0";